import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetRazorpayOrderId(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/checkout/razorpayorderid`,
      payload
    );
  },
  GetPaymentStatus(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/checkout/razorpaypaymentstatus`,
      payload
    );
  },
  GetPaymentStatusByOrderID(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/checkout/razorpaypaymentstatusbyOrderID`,
      payload
    );
  },
  OnlyFndCheckout(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/checkout/only-fnd-checkout`,
      payload
    );
  },
  CancelTransaction(payload) {
    return Api().post(
      `/${API_VERSION}/webapp/checkout/cancel-transaction`,
      payload
    );
  },
  GetCharges(payload) {
    return Api().post(`/${API_VERSION}/webapp/checkout/charges`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/CheckoutService.js